import React from 'react';
import './home.css'
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";

import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import allStrings from "../../assets/strings";
import { connect } from 'react-redux';
import {withRouter,NavLink,Redirect} from 'react-router-dom'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import {setUser} from '../../redux/actions/AuthActions'
import Skeleton from 'react-loading-skeleton';
import moment from 'moment'
import { Spin } from 'antd';

class Home extends React.Component {
  
  state = {
    count:[],
    tops:[],
    topDsps:[],
    user:[],
    loading:true,
    clients:[],
    graphclients:[],
    days:[],
    daysEN:[],
    daysAR:[],
    maxValue:0,
    graphStep:0,
   
  }
  
   
  constructor(props){
    super(props)
    this.getCount()
    this.getClients()
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
      moment.locale('ar');
    }else{
      allStrings.setLanguage('en')
      moment.locale('en');
    } 

  }

  getCount = () => {
    axios.get(`${BASE_END_POINT}admin/count`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    })
    .then(response=>{
      console.log(response.data)
      this.setState({count:response.data,loading:false,topDsps:response.data.topDsps})
    })
    .catch(error=>{
      console.log("ALL count ERROR")
      console.log(error.response)
    })
  }
  getClients = () => {
    axios.get(`${BASE_END_POINT}clients?page=1&limit=7`,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log(response.data.data)
      this.setState({clients:response.data.data})
    })
    .catch(error=>{
      console.log("ALL clients ERROR")
      console.log(error.response)
    })
  }

  componentDidMount(){
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
      moment.locale('ar');
    }else{
      allStrings.setLanguage('en')
      moment.locale('en');
    } 
  
  }

  render(){
    let {loading,topDsps} = this.state;
    if(this.props.currentUser.user.type === "SALES-MAN") return <Redirect to='/Clients' />
  return (
    <div className="Home">
      <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{color:'#233b5b'}}>
      <MDBContainer> 
        <MDBRow>
          
         <div style={{textAlign:this.props.isRTL? 'right':'left',
         flexDirection:this.props.isRTL?'row':'row-reverse',
         display:this.props.isRTL?'': 'flex',
         width:this.props.isRTL?'100%': '',padding: '5px 20px 25px'}}>
          <span  style={{
            display: 'inline-block',
            color: '#43425D',
            fontSize:'22px'}}>{allStrings.statistic}</span>
          <span  style={{fontFamily:'system-ui',fontWeight:'bold',fontSize:'22px',display: 'inline-block',
            color: '#43425D',margin:'6px',lineHeight:this.props.isRTL?'auto':'15px'}}>|</span>
          <span style={{fontFamily:'system-ui',fontWeight:'bold',fontSize:'22px',display: 'inline-block',
            color: '#43425D'}}>{allStrings.overView}</span>
         </div>
         
        </MDBRow>
        <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>

          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.dspCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img crossOrigin="anonymous"alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart1.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.dspCount}</p>
                  
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.salesCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img crossOrigin="anonymous"alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart5.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.salesCount}</p>
                    
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.clientsCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img crossOrigin="anonymous"alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart3.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.clientsCount}</p>
                    
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.acceptedClients}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img crossOrigin="anonymous"alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart2.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.acceptedClients}</p>
                    
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.pendingClients}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img crossOrigin="anonymous"alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart4.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.pendingClients}</p>
                   
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
          
          <MDBCol xl="4" lg="4" md="6" sm="12" style={{marginBottom: '1.5rem'}}>
            <div className="theCard">
              <p className="topCard" style={{textAlign: this.props.isRTL?'right':'left'}}>{allStrings.saleDoneCount}</p>
                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                  <MDBCol  md="6" sm="6">
                    <img crossOrigin="anonymous"alt="" style={{width: '100%',marginTop: '20px'}} src={require('../../assets/images/Bar Chart6.png')}></img>
                  </MDBCol>
                  <MDBCol  md="6" sm="6">
                    <p className="count" style={{textAlign: this.props.isRTL?'right':'left'}}>{loading?<Skeleton height={20} />:this.state.count.saleDoneCount}</p>
                  </MDBCol>
                </MDBRow>
            </div>
          </MDBCol>
        </MDBRow>
       
      
        <br></br>
        <br></br>
        
        <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
          <MDBCol xl="8" lg="7" md="12" sm="12">
            <div className="theCard" style={{minHeight:'505px'}}>
              <p className="topCard" style={{color: '#43425D',textAlign: this.props.isRTL?'right':'left'}}>{allStrings.clients}</p>
              <br></br>
              <table className="table table-borderless">
                <thead className="thead-light">
                  <tr >
                    <th scope="col">{allStrings.clientName}</th>
                    <th scope="col">{allStrings.dsp}</th>
                    <th scope="col">{allStrings.status}</th>
                  </tr>
                </thead>
                <tbody>
                {this.state.loading?
                
                <div style={{width:"100%"}} >
                  <Skeleton height={40} /> 
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                  <Skeleton height={40}/>
                </div>
                :
                this.state.clients.length > 0 ?
                  this.state.clients.map(val=>(
                      <tr onClick={()=>this.props.history.push("/dealInfo",{data:val})}>
                        
                        <td>{val.clientName?val.clientName:""}</td>
                        <th>{val.user?val.user.fullname:""}</th>
                        <th>{val.status==="PENDING"?allStrings.pending:val.status==="IN-CONTACT"?allStrings.inContact:val.status==="REJECTED"?allStrings.rejected:val.status==="SALE-DONE"?allStrings.saleDone:allStrings.disqualified}</th>
                      </tr>
                  ))
                  :
                  <tr style={{height: '300px'}}>
                      <th colSpan="8" className="noData" style={{background:"#fff"}}>
                      <p style={{marginTop:'10rem',textAlign:'center',}}>{allStrings.noData}</p> 
                      </th>
                  </tr>
                }
                </tbody>
              </table>
              <hr></hr>
              <NavLink to="clients">
                <span style={{display:'block',marginBottom:'8px'}}>{allStrings.showAll}</span>
              </NavLink>
            </div>
          </MDBCol>
          <MDBCol xl="4" lg="5" md="12" sm="12">
            <div className="theCard" style={{minHeight:'505px'}}>
              <NavLink to="users">
                <span style={{position: 'absolute'}}>{allStrings.showAll}</span>
              </NavLink>
              <p className="topCard"  style={{color: '#43425D'}}>{allStrings.topDsps}</p>
              <img crossOrigin="anonymous"alt="" width="100%" src={require('../../assets/images/Map.png')}></img>
              <div>
                <span className="rightSpan">{topDsps[0]?topDsps[0].fullname?topDsps[0].fullname.substr(0,10):"-":"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{color:'#54D8FF'}}></span>
                  <span className="spanNum">{topDsps[0]?topDsps[0].earns?topDsps[0].earns:"-":"-"}</span>
                </p>
              </div>
              <div>
                <span className="rightSpan">{topDsps[1]?topDsps[1].fullname?topDsps[1].fullname.substr(0,10):"-":"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#5EE2A0'}}></span>
                  <span className="spanNum">{topDsps[1]?topDsps[1].earns?topDsps[1].earns:"-":"-"}</span>
                </p>
              </div>
              <div>
                <span className="rightSpan">{topDsps[2]?topDsps[2].fullname?topDsps[2].fullname.substr(0,10):"-":"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FFA177'}}></span>
                  <span className="spanNum">{topDsps[2]?topDsps[2].earns?topDsps[2].earns:"-":"-"}</span>
                </p>
              </div>
              <div>
                <span className="rightSpan">{topDsps[3]?topDsps[3].fullname?topDsps[3].fullname.substr(0,10):"-":"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#A3A1FB'}}></span>
                  <span className="spanNum">{topDsps[3]?topDsps[3].earns?topDsps[3].earns:"-":"-"}</span>
                </p>
              </div>
              <div>
                <span className="rightSpan">{topDsps[4]?topDsps[4].fullname?topDsps[4].fullname.substr(0,10):"-":"-"}</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FBA69D'}}></span>
                  <span className="spanNum">{topDsps[4]?topDsps[4].earns?topDsps[4].earns:"-":"-"}</span>
                </p>
              </div>
              <div>
                <span className="rightSpan">{topDsps[5]?topDsps[5].fullname?topDsps[5].fullname.substr(0,10):"-":"-" }</span>
                <p style={{marginBottom:0}}>
                  <span className="spanCicle" style={{borderColor:'#FF7CC3'}}></span>
                  <span className="spanNum">{topDsps[5]?topDsps[5].earns?topDsps[5].earns:"-":"-"}</span>
                </p>
              </div>
            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer> 
      </Spin>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  setUser,
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(Home)
);
